/**
 * @file API 相关常量
 */

import { apiHost } from './env'

export const apiPrefix = `${apiHost}/api/proxy/jarvis-business`
